module.exports = __webpack_public_path__ + "img/pill.63080848.svg";